import React from "react";
import { Verify } from "../containers/verify/Verify";

export function VerifyPage() {
  return <Verify/>;
}
